import React from "react";
import ReactPlayer from "react-player";

export const MemoizedReactPlayer = React.memo(({ file, index, playerRefs }) => {
  return (
    <ReactPlayer
      ref={(ref) => (playerRefs.current[index] = ref)}
      width={"100%"}
      height={"100%"}
      url={URL.createObjectURL(file)}
      controls
    />
  );
});
